export default __webpack_public_path__ + "static/media/D1969_07_25_San_Mauro_La_Bruca_1.d73906ac.jpg";